import { WithServiceId } from '@mews-commander/types';
import { TooltippedIcon } from '@mews-commander/ui';
import { LocalizedCurrencyValue, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Container, IconName, Position, Stack, StackItem } from '@optimus-web/core';
import { useProductServiceOrderTotal } from '../hooks';

const ProductServiceTotalRow = ({ serviceId }: WithServiceId) => {
    const { isConvertedToDefaultCurrency, ...rest } = useProductServiceOrderTotal({ serviceId });

    return (
        <Container padding={['200', '50']}>
            <Stack alignment="end" itemAlignment="center">
                <StackItem>
                    <Container padding={['0', '100']}>
                        <LocalizedText textKey={TextKey.Total} />:
                    </Container>
                </StackItem>
                <StackItem width="25%">
                    <Stack alignment="end" distribution="space-between" itemAlignment="center">
                        <StackItem>
                            {isConvertedToDefaultCurrency && (
                                <TooltippedIcon
                                    value={IconName.Help}
                                    tooltip={TextKey.TotalConvertedToDefault}
                                    size="small"
                                    tooltipPosition={Position.Top}
                                />
                            )}
                        </StackItem>
                        <LocalizedCurrencyValue value={rest} />
                    </Stack>
                </StackItem>
            </Stack>
        </Container>
    );
};

export default ProductServiceTotalRow;
